import React from "react";

import { Row, Column, Teaser } from "@ard-online/component-styleguide";
import { TeaserCont } from "../styles";

import ChannelMap from "../ChannelMap";

const ardLogo = require("@ard-online/component-styleguide/dist/assets/images/logos/SVG/colored/ard.svg");
const dasErsteLogo = require("@ard-online/component-styleguide/dist/assets/images/logos/SVG/colored/daserste.svg");

const channels = {
  "das-erste": [
    {
      type: "text",
      title: "Das Erste",
      text: (
        <div className="text">
          <p>
            Das Erste ist das quotenstärkste ARD-Programm im deutschen Fernsehen
            und wird gemeinsam von den neun ARD-Landesrundfunkanstalten
            betrieben. Generationsübergreifend steht es für Glaubwürdigkeit und
            Kompetenz.
          </p>
          <p>
            Rund 50 Millionen Menschen schalten Das Erste wöchentlich ein. Damit
            ist es eines der meistgesehenen Fernsehprogramme in Deutschland und
            bietet laut repräsentativen Umfragen die qualitativ hochwertigsten
            Inhalte.
          </p>
          <p>
            Als bevorzugte Informationsquelle in Deutschland fördert es das
            Interesse an Politik und regt zur Diskussion an. Durchschnittlich
            machen informative Inhalte rund <nobr>42 %</nobr> und fiktionale
            Programme <nobr>38 %</nobr> des Programmangebots aus.
          </p>
        </div>
      ),
      href: "https://www.daserste.de",
      image: {
        src: require("../logos/das-erste_vert.svg"),
        alt: "Logo Das Erste",
      },
    },
  ],
  regional: [
    {
      type: "text",
      title: "BR",
      text: "Bayerischer Rundfunk",
      href: "https://www.br.de/br-fernsehen/",
      image: {
        src: require("@ard-online/component-styleguide/dist/assets/images/logos/SVG/colored/br.svg"),
        alt: "Logo BR",
      },
    },
    {
      type: "text",
      title: "HR",
      text: "Hessischer Rundfunk",
      href: "https://www.hr-fernsehen.de",
      image: {
        src: require("@ard-online/component-styleguide/dist/assets/images/logos/SVG/colored/hr.svg"),
        alt: "Logo BR",
      },
    },
    {
      type: "text",
      title: "MDR",
      text: "Mitteldeutscher Rundfunk",
      href: "https://www.mdr.de/tv",
      image: {
        src: require("@ard-online/component-styleguide/dist/assets/images/logos/SVG/colored/mdr.svg"),
        alt: "Logo MDR",
      },
    },
    {
      type: "text",
      title: "NDR",
      text: "Norddeutscher Rundfunk",
      href: "https://www.ndr.de/fernsehen/",
      image: {
        src: require("@ard-online/component-styleguide/dist/assets/images/logos/SVG/colored/ndr.svg"),
        alt: "Logo NDR",
      },
    },
    {
      type: "text",
      title: "Radio Bremen",
      text: "",
      href: "https://dein.radiobremen.de/",
      image: {
        src: require("@ard-online/component-styleguide/dist/assets/images/logos/SVG/colored/radiobremen.svg"),
        alt: "Logo Radio Bremen",
      },
    },
    {
      type: "text",
      title: "RBB",
      text: "Rundfunk Berlin-Brandenburg",
      href: "https://www.rbb-online.de/fernsehen",
      image: {
        src: require("@ard-online/component-styleguide/dist/assets/images/logos/SVG/colored/rbb.svg"),
        alt: "Logo RBB",
      },
    },
    {
      type: "text",
      title: "SR",
      text: "Saarländischer Rundfunk",
      href: "https://www.sr.de/sr/home/fernsehen/index.html",
      image: {
        src: require("../logos/sr.svg"),
        alt: "Logo SR",
      },
    },
    {
      type: "text",
      title: "SWR",
      text: "Südwestrundfunk",
      href: "https://www.swrfernsehen.de",
      image: {
        src: require("@ard-online/component-styleguide/dist/assets/images/logos/SVG/colored/swr.svg"),
        alt: "Logo SWR",
      },
    },
    {
      type: "text",
      title: "WDR",
      text: "Westdeutscher Rundfunk",
      href: "https://www1.wdr.de/fernsehen",
      image: {
        src: require("@ard-online/component-styleguide/dist/assets/images/logos/SVG/colored/wdr.svg"),
        alt: "Logo WDR",
      },
    },
  ],
  digital: [
    {
      type: "text",
      title: "ONE",
      text: (
        <div className="text">
          <p>
            Mit seinem Programmprofil aus Serie, Film, Unterhaltung und Events
            und einer jungen frischen Ansprache ist ONE innerhalb der
            ARD-Familie der Fiction- und Entertainment-Kanal für 29- bis
            49-Jährige. Fiktionale Serien gehören dabei zu den prägendsten und
            erfolgreichsten Inhalten.
          </p>
        </div>
      ),
      href: "https://www.ardmediathek.de/one/",
      image: {
        src: require("../logos/one.svg"),
        alt: "Logo ONE",
      },
    },
    {
      type: "text",
      title: "tagesschau24",
      text: (
        <div className="text">
          <p>
            Der Informationskanal liefert Nachrichten aus Politik, Wirtschaft,
            Kultur, Sport und Wissenschaft – aktuell, konsequent, umfangreich
            und 24 Stunden an sieben Tagen. Hinzu kommen Magazine, Talkshows,
            Reportagen und Dokumentationen. tagesschau24 entwickelt neue
            crossmediale redaktionelle Informationsformate und treibt
            Innovationen auch im technischen Bereich voran.
          </p>
        </div>
      ),
      href: "https://www.tagesschau24.de/",
      image: {
        src: require("@ard-online/component-styleguide/dist/assets/images/logos/SVG/colored/tagesschau24.svg"),
        alt: "Logo tagesschau24",
      },
    },
    {
      type: "text",
      title: "ARD-alpha",
      text: (
        <div className="text">
          <p>
            Der einzige und einzigartige Bildungskanal im deutschsprachigen Raum
            vereint die besten Wissens- und Wissenschaftsformate der
            ARD-Familie. Und das nicht nur für Erwachsene. Der Nachwuchs bekommt
            Wissen kindgerecht vermittelt. ARD-alpha erklärt, ordnet ein,
            liefert Anregungen und Hintergrundinformationen.
          </p>
        </div>
      ),
      href: "https://www.ardmediathek.de/alpha/",
      image: {
        src: require("../logos/ard-alpha.svg"),
        alt: "Logo ARD-alpha",
      },
    },
  ],
  partnership: [
    {
      type: "text",
      title: "3sat",
      text: (
        <div className="text">
          <p>
            Kultur, Wissenschaft und Bildung sind die thematischen Säulen des
            3sat-Programms, das gemeinschaftlich von ZDF, ARD, ORF und SRG
            produziert wird. Es liefert dem Publikum aus Deutschland, Österreich
            und der Schweiz Kultur in allen Facetten: ob tagesaktuell oder
            hintergründig, ob Literatur, Film, Kunst, Kabarett, Architektur oder
            Musik.
          </p>
        </div>
      ),
      href: "https://www.3sat.de/",
      image: {
        src: require("@ard-online/component-styleguide/dist/assets/images/logos/SVG/colored/dreiSat.svg"),
        alt: "Logo 3sat",
      },
    },
    {
      type: "text",
      title: "KiKA",
      text: (
        <div className="text">
          <p>
            Information, Bildung, Beratung und Unterhaltung für Kinder liefert
            der KiKA und fördert damit einen vernünftigen Umgang mit dem Medium
            Fernsehen. Frische, vielfältige und innovative Angebote machen den
            KiKA zum beliebtesten Kindersender.
          </p>
        </div>
      ),
      href: "https://www.kika.de/",
      image: {
        src: require("@ard-online/component-styleguide/dist/assets/images/logos/SVG/colored/kika.svg"),
        alt: "Logo KiKA",
      },
    },
    {
      type: "text",
      title: "phoenix",
      text: (
        <div className="text">
          <p>
            Der Ereignis- und Dokumentationskanal von ARD und ZDF legt den
            Schwerpunkt auf eine besonders ausführliche, analytische und
            differenzierte Berichterstattung. Dafür werden Live-Ereignisse eng
            mit Dokumentationen, Gesprächssendungen und Angeboten der digitalen
            Medien verzahnt. Auch die authentische Abbildung der Arbeit der
            politischen Institutionen und demokratischer Prozesse ist Teil des
            Programmauftrags.
          </p>
        </div>
      ),
      href: "https://www.phoenix.de/",
      image: {
        src: require("../logos/phoenix.svg"),
        alt: "Logo phoenix",
      },
    },
  ],
};

export default function TvChannelsSection() {
  const getClassName = (title) => title.replace(/\s+/g, "-").toLowerCase();

  const _jumpTo = (e) => {
    e.preventDefault();

    ((selector, yOffset = -96) => {
      selector = selector.current ? selector.current : selector;
      const y =
        selector.getBoundingClientRect().top + window.pageYOffset + yOffset;

      window.scrollTo({ top: y, behavior: "smooth" });
    })(document.querySelector(e.target.getAttribute("href")));
  };

  return (
    <section id="tv-channels">
      <Row>
        <Column>
          <h2>Fernsehen</h2>
          <p>
            <strong>
              So viel Programmvielfalt bietet Ihnen nur{" "}
              <a href="https://ard.de" target="_blank" rel="noopener">
                die ARD
              </a>
              : 16 erstklassige deutsche TV-Sender aus einer Hand.
            </strong>
          </p>
          <p>
            Zum Portfolio von ARD Channels International gehören das
            Gemeinschaftsprogramm{" "}
            <a href="#flagship-channel" onClick={_jumpTo}>
              Das Erste
            </a>
            , die{" "}
            <a href="#regional-channels" onClick={_jumpTo}>
              regionalen Fernsehprogramme
            </a>{" "}
            der neun ARD-Landesrundfunkanstalten (die "Dritten") sowie die
            Digitalprogramme{" "}
            <a href="#digital-channels" onClick={_jumpTo}>
              ONE
            </a>
            ,{" "}
            <a href="#digital-channels" onClick={_jumpTo}>
              tagesschau24
            </a>{" "}
            und{" "}
            <a href="#digital-channels" onClick={_jumpTo}>
              ARD-alpha
            </a>
            . Außerdem beinhaltet unser Portfolio die Kooperationsprogramme{" "}
            <a href="#partnership-channels" onClick={_jumpTo}>
              3sat
            </a>
            ,{" "}
            <a href="#partnership-channels" onClick={_jumpTo}>
              KiKA
            </a>{" "}
            und{" "}
            <a href="#partnership-channels" onClick={_jumpTo}>
              phoenix
            </a>
            .
          </p>
        </Column>
      </Row>
      <Row>
        <Column>
          <h3 id="flagship-channel">Die erste Wahl in der ARD</h3>
          <TeaserCont className="channel-list">
            {channels["das-erste"].map((channel, index) => (
              <div className={"channelLogo " + getClassName(channel.title)}>
                <Teaser
                  id={channel.title}
                  key={index}
                  {...channel}
                  textPosition="besideImage"
                />
              </div>
            ))}
          </TeaserCont>
          <p className="inlineImages">
            Oftmals wird{" "}
            <a href="https://www.ard.de">
              <img
                className="inlineLogo"
                src={ardLogo}
                height="40"
                alt="ARD Logo"
                title="ARD"
              />
            </a>{" "}
            mit{" "}
            <a href="https://www.daserste.de">
              <img
                className="inlineLogo"
                src={dasErsteLogo}
                height="54"
                alt="Das Erste Logo"
                title="Das Erste"
              />
            </a>{" "}
            verwechselt.
            <br />
            Die ARD ist die Dachorganisation [Arbeitsgemeinschaft der
            öffentlich-rechtlichen Rundfunkanstalten der Bundesrepublik
            Deutschland] und Das Erste ihr gemeinschaftliches Fernsehprogramm.
          </p>
        </Column>
      </Row>
      <Row className="mt-2">
        <Column all={12} s={6}>
          <h3 id="regional-channels">
            Regionale Fernsehsender der ARD (Die "Dritten")
          </h3>
          <p>
            <strong>Nah bei den Menschen</strong>
          </p>
          <ul>
            <li>
              Lokalbezug und Qualität prägen die Informations-, Service- und
              Unterhaltungsangebote der neun Regionalsender.
            </li>
            <li>
              Aktuell und traditionell, heimatverbunden und weltoffen, kreativ
              und verlässlich – Vielfalt pur.
            </li>
            <li>
              Täglich schalten durchschnittlich rund 25 Millionen Menschen in
              Deutschland einen der Regionalsender ein.
            </li>
          </ul>
        </Column>
        <Column all={12} s={6}>
          <ChannelMap></ChannelMap>
        </Column>
      </Row>
      <Row className="regional-channels">
        {channels["regional"].map((channel, index) => (
          <Column key={index} all={6} xs={6} s={4} m={3}>
            <TeaserCont
              id={channel.title}
              className={"channelLogo " + getClassName(channel.title)}
            >
              <Teaser {...channel} hoverEffect={"default"} />
            </TeaserCont>
          </Column>
        ))}
      </Row>
      <Row className="mt-2">
        <Column>
          <h3 id="digital-channels">Digitale Programme der ARD</h3>
          <TeaserCont className="channel-list">
            {channels["digital"].map((channel, index) => (
              <div className={"channelLogo " + getClassName(channel.title)}>
                <Teaser
                  id={channel.title}
                  key={index}
                  {...channel}
                  textPosition="besideImage"
                />
              </div>
            ))}
          </TeaserCont>
        </Column>
      </Row>
      <Row>
        <Column>
          <h3 id="partnership-channels">Kooperationsprogramme der ARD</h3>
          <p>
            <strong>
              Die ARD produziert Partnerprogramme mit anderen
              öffentlich-rechtlichen Sendern aus Deutschland und Europa.
            </strong>
          </p>
          <TeaserCont className="channel-list">
            {channels["partnership"].map((channel, index) => (
              <div className={"channelLogo " + getClassName(channel.title)}>
                <Teaser
                  key={index}
                  id={channel.title}
                  {...channel}
                  textPosition="besideImage"
                />
              </div>
            ))}
          </TeaserCont>
        </Column>
      </Row>
    </section>
  );
}
